import { Component, OnInit, Output, EventEmitter, Input, ChangeDetectorRef, NgZone } from "@angular/core";
import { RxStore } from "src/app/store";
import { FormGroup } from "@angular/forms";
import { Observable, Subject } from "rxjs";
import { PopupsCommonLogicUtil } from "src/app/utils/popups-common-logic.util";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-ed-rx",
  templateUrl: "./ed-rx.component.html"
})
export class EdRxComponent implements OnInit {
    edrxFGBS$: Observable<FormGroup>;
    edcrtFGBS$: Observable<FormGroup>;
    @Input() FiledRx: any;
    @Input() SelectedValue: boolean;
    drugInfoFromRecall: any;
    @Input()
    set drugInfoFrmRecall(val) {
        if (val) {
            this.drugInfoFromRecall = val;
        }
    }
    @Input() errorEditInfo:any;
    @Input() rxFG:any;
    @Input() isFromRecall: boolean;
    @Input() isFromCntrlFileErr: boolean;
    @Input() isNYCntrlFileErr: boolean;
    @Input() isFromLargeValues: boolean;
    @Input() largerValuesForDisplay: any;
    @Input() PatientId:any;
    @Input() IsFromRxHistory:any
  
    @Input() OpenReverse: any;
    @Input() openFrom:any;
    @Input() rejectedTransRevsInfo: any;
    
    @Output() CloseEditMode = new EventEmitter<string>();
    @Output() CloseAndReopen = new EventEmitter<any>();
    modalRef: any;
    reloadeditrx:boolean = true;
    unsubscribe$ : Subject<void> = new Subject();
    constructor(private _rxStore: RxStore, 
        private _mdlServ: NgbModal,
        public zone: NgZone,
        private _cdr: ChangeDetectorRef,
        private _popupLogics: PopupsCommonLogicUtil) {
        this.edrxFGBS$ = this._rxStore.edrxFGBS$;
        this.edcrtFGBS$ = this._rxStore.edcrtFGBS$;
    }

    async ngOnInit() {
        this._rxStore.priceCalculationsForSetting(false);
         this._rxStore.edcrtFGBS$.pipe(takeUntil(this.unsubscribe$)).subscribe((resp) => {
            if(resp?.value?.IsCorrect){
                resp.value.IsCorrect = false;
                this.reloadeditrx=false
                setTimeout(()=>{
                this.reloadeditrx=true;
                },5)
            }
        });
    }

    CloseEitRxPopUp(val, type?: any) {
       if (type) {
            this.SelectedValue = val.isNPPatientValue;
            this.CloseAndReopen.emit(val);
        } else if (val === "cancel") {
            this.CloseEditMode.emit("cancel");
        } else {
            this.CloseEditMode.emit("Refresh");
        }
    }

    ngOnDestroy(){
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

}
